angular.module('ihestiaCommonDirectives.platformHelper', [
  'ihestiaCommonDirectives.configHelper'
]);